import { useEffect, useState } from "react";
import { blogCategory } from "../../data/DataBlog";
import { Skeleton } from "../Skeleton";
import BlogItem from "./BlogItem";
import { getImageUrl, getBlogs } from "src/utils/magnolia";

type BlogOtherCategoryProps = {
  maxWidth?: string;
  category?: string;
};

export const BlogOtherCategory = ({
  maxWidth,
  category,
}: BlogOtherCategoryProps) => {
  const [popularBlog, setPopularBlog] = useState([]);
  const [isLoadingPopular, setIsLoadingPopular] = useState(true);

  const getBlogList = async () => {
    const { data, status } = await getBlogs({
      params: {
        limit: 5,
        taxonomy: "Terpopuler",
      },
    });

    if (status === 200) {
      setPopularBlog(data.results);
      setIsLoadingPopular(false);
    }
  };

  useEffect(() => {
    getBlogList();
  }, []);

  return (
    <div className="right-section">
      <div className="kategori-lainnya">
        <p>Kategori Menarik Lainnya</p>
        <div>
          {blogCategory.slice(2, 8).map((data, key) => {
            if (category === data.taxonomy) return null;

            return (
              <a href={`/blog/category/${data.taxonomy}`} key={key}>
                {data.name}
              </a>
            );
          })}
        </div>
      </div>
      <div className="artikel-populer">
        <p>Terpopuler</p>
        {isLoadingPopular ? (
          <Skeleton
            width="320px"
            amount={5}
            height="77.5px"
            margin="0 12px 36px"
          ></Skeleton>
        ) : (
          popularBlog &&
          popularBlog.map((data, key) => {
            return (
              <div key={key}>
                <BlogItem
                  key={key}
                  thumbnail={getImageUrl(data.thumbnail)}
                  title={data.title}
                  excerpt={data.excerpt}
                  slug={data.slug}
                  taxonomy={data.taxonomy}
                  landscape={true}
                />
              </div>
            );
          })
        )}
      </div>
      <style jsx>{`
        .right-section {
          max-width: ${maxWidth ? maxWidth : ""};
        }
        .kategori-lainnya {
          margin-left: 10px;
        }
        .kategori-lainnya p {
          font-weight: bold;
          color: #676767;
          font-size: 17px;
          margin-top: 0;
        }
        .kategori-lainnya div {
          display: flex;
          flex-direction: column;
        }
        .artikel-populer {
          margin-top: 64px;
        }
        .artikel-populer p {
          margin: 0 0 16px 10px;
          font-weight: bold;
          color: #676767;
          font-size: 17px;
        }
        @media only screen and (max-width: 600px) {
          .right-section {
            max-width: none;
            margin-left: 6px;
          }
        }
      `}</style>
    </div>
  );
};
